var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "image-modal-cover" }, [
    _c(
      "div",
      {
        staticClass: "stopwatch-setting-container",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("GrmCamstudyOptionModal", {
          attrs: {
            name: "stopwatch-setting",
            list: [
              { name: _vm.$t("camstudy.stopwatch.todayStudyTime") },
              { name: _vm.$t("camstudy.stopwatch.targetStudyTime") },
              { name: _vm.$t("camstudy.stopwatch.totalStudyTime") },
              { name: _vm.$t("camstudy.stopwatch.myDDay") },
              { name: _vm.$t("camstudy.stopwatch.studyPeriod") },
            ],
            value: _vm.optionData,
            type: "checkbox",
            title: _vm.$t("camstudy.stopwatch.setting.title"),
          },
          on: { onCloseOption: _vm.onCloseOption, onNextAct: _vm.onNextAct },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }